import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DismissablePopover from '../../DismissablePopover/DismissablePopover';
import { isFullscreenSelector } from '@vh/slices/vh-player/VHPlayerSlice';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

/**
 * @type {React.FC<{
 *  attachToRef: React.MutableRefObject<HTMLElement | null>;
 *  checkDimensionsRef: React.MutableRefObject<HTMLElement | null>;
 * }>}
 */
const NarrowScreenWarningPopover = ({ attachToRef, checkDimensionsRef }) => {
  const [showUseWarningPopover, setShowUseWarningPopover] = useState(false);
  const [hasDismissed, setHasDismissed] = useState(false);
  const isFullscreen = useSelector(isFullscreenSelector);
  const setInactiveTooltip = useCallback(() => {
    setShowUseWarningPopover(false);
    setHasDismissed(true);
  }, []);

  const { t } = useTranslation();

  useEffect(() => {
    if (
      checkDimensionsRef.current &&
      checkDimensionsRef.current.clientWidth < 1100
    ) {
      setShowUseWarningPopover(true);
    }
  }, [checkDimensionsRef]);

  return (
    <DismissablePopover
      attachToRef={attachToRef}
      position={'bottom-left'}
      active={showUseWarningPopover && !isFullscreen}
      setInactive={setInactiveTooltip}
      type="info"
    >
      <div>{t('narrowScreenWarning')}</div>
    </DismissablePopover>
  );
};

NarrowScreenWarningPopover.propTypes = {
  popoverPortalElementRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  attachToRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    .isRequired,
  checkDimensionsRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
};

export default NarrowScreenWarningPopover;
